import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import BackButtonMenu from '../../../../components/BackButtonMenu';

class Kereszt extends React.Component {
    render() {
        return (
            <img src={process.env.PUBLIC_URL + '/assets/kereszt.png'} alt="kereszt" className='kereszt-icon-projekttortenet' />
        );
    }
}

function ProjektTortenet() {

    // Preload the kereszt image to prevent flickering
    useEffect(() => {
        const img = new Image();
        img.src = process.env.PUBLIC_URL + '/assets/kereszt.png';
    }, []);



    return (
        <>
            <div className='submenu-container'>
                    <div className='submenu-text-container'>
                        <Kereszt />
                        <Link to={"/projekt-kezdetei"} className='submenu-list-item'>
                          A projekt kezdetei.<br />
                          Előzmények és a kezdeményezés programjai 2005-től 2019-ig
                        </Link>
                    </div>
                    <div className='submenu-text-container'>
                        <Kereszt />
                        <Link to={"/egy-hajoban-kapcs"} className='submenu-list-item'>
                          Az Egy hajóban... projekt <br />
                          kapcsolódása a Mohácsi csata emlékzarándoklathoz
                        </Link>
                    </div>
                    <BackButtonMenu to="/projekt" />
            </div>
        </>
    );
}

export default ProjektTortenet;
